import { useState, type FC } from 'react';

import { FilterActions } from '$/components/core/Collection/CollectionFilter/components/FilterActions';
import { MultiSelectionMenuItem } from '$/components/core/Collection/CollectionFilter/components/MultiSelectionMenuItem';
import { type FilterOptionGroup } from '$/services/usecases/filter';
import { getCollectionStore } from '$/stores/useCollectionStore';

interface Props {
  filter: FilterOptionGroup;
  onMenuClose: () => void;
  hideAmounts?: boolean;
  hideActions?: boolean;
  compactMode?: boolean;
}

export const MultiFilter: FC<Props> = ({
  filter,
  hideAmounts = false,
  hideActions = false,
  compactMode = false,
  onMenuClose,
}) => {
  const [activeChanges, setActiveChanges] = useState(false);

  return (
    <>
      {filter.items.map((option) => (
        <MultiSelectionMenuItem
          key={option.value}
          id={option.value}
          color={option.payload}
          name={option.displayName}
          isChecked={getCollectionStore().isFilterActive(
            filter.searchField,
            option.value,
          )}
          amount={hideAmounts ? undefined : option.count}
          onChange={() => {
            setActiveChanges(true);
            getCollectionStore().toggleAppliedFilterOption(
              { option: filter.searchField, value: option.value },
              { isMultiFilter: true },
            );
          }}
          compactMode={compactMode}
        />
      ))}

      {!hideActions && (
        <FilterActions
          anyFilterActive={getCollectionStore().isAnyCategoryActive([
            filter.searchField,
          ])}
          activeChanges={activeChanges}
          onSubmit={() => {
            onMenuClose();
          }}
          onReset={() => {
            getCollectionStore().resetAppliedFilterOption([filter.searchField]);
            onMenuClose();
          }}
          px='3'
          py='5'
        />
      )}
    </>
  );
};
